import { render } from "./Settings-page.vue?vue&type=template&id=0fd13ac6&scoped=true"
import script from "./Settings-page.vue?vue&type=script&lang=js"
export * from "./Settings-page.vue?vue&type=script&lang=js"

import "./Settings-page.vue?vue&type=style&index=0&id=0fd13ac6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd13ac6"]])

export default __exports__